export default {
    name: 'TableExpand',
    functional: true,
    props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
            type: Object,
            default: null
        }
    },
    render: (h, ctx) => {
        const params = {
            row: ctx.props.row,
            index: ctx.props.index
        };
        if (ctx.props.column) {
                params.column = ctx.props.column;
        }
        const paramsTable =ctx.parent.$parent.$parent.$parent;
        return ctx.props.render(h, params,paramsTable);
    }
};



// WEBPACK FOOTER //
// ./src/components/table/expand.js